var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiamond = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  fill: "currentColor",
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.612.667 2.252 4h-5.73l2.254-4zm2.311 4.666H4.076l2.848 7.074h.154zm.359-.666h3.384V4.6L10.462 1a1 1 0 0 0-.747-.334H8.017zm-6.59.666H.333v.154l5.937 6.74c.075.084.21 0 .168-.104zm.026-.666 2.264-4H4.285a1 1 0 0 0-.747.335L.333 4.6v.066zm6.59.666-2.747 6.79c-.042.104.094.188.168.104l5.937-6.74v-.154z"
})));
export default SvgDiamond;